export default {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};
